import Select from "react-select";
import {customTheme} from "../../../../../IntReports/LocationTab";
import {useContext} from "react";
import TechnicalEngagementContext from "../../TechnicalEngagementContext";
import stepperContext from "../StepperContext";

const OpportunityDropdown = (props) => {
    const {setOpportunityValue, setTechnicalEngagementValue, opportunitiesByIdData, customerName} = props;
    const { technicalEngagement,setTechnicalEngagement} = useContext(TechnicalEngagementContext);
    const { opportunity,setOpportunity} = useContext(stepperContext);


    const handleSelect = (val) => {
        setOpportunityValue(val);
        setOpportunity(val)
        setTechnicalEngagement(prevState => {
            return{
                ...prevState,
                opportunity: val.value
            }
        });
        setTechnicalEngagementValue({});
    }

  return(
              <Select
                  id={"opportunity_dropdown"}
                  placeholder={<div>Select Opportunity</div>}
                  options={opportunitiesByIdData?.map(opportunity => {
                      return {label: opportunity.name, value: opportunity.id}
                  })}
                  onChange={handleSelect}
                  theme={customTheme}
                  value={ opportunity  }
                  isDisabled={technicalEngagement?.accountName === "" || opportunitiesByIdData?.length === 0 || customerName === ""}
              />
  );

}
export default OpportunityDropdown;
